import { HttpMethod } from "./HttpMethod";
import { WebApi } from "./WebApi";
import { isNullOrUndefined } from "../utils/DefineFunction";
const reserved = {
    method: true,
    url: true
};
export class DefaultRequestFactory {
    create(command) {
        let data = this.createData(command);
        let config = this.createConfig(command, data);
        if (command.configure) {
            command.configure(config, data);
        }
        return config;
    }
    createData(command) {
        let data = {};
        let self = command;
        for (let name of this.getFieldNames(command)) {
            data[name] = self[name];
        }
        return data;
    }
    getFieldNames(command) {
        let names = [];
        for (let name of Object.getOwnPropertyNames(command)) {
            if (this.filter(command, name)) {
                names.push(name);
            }
        }
        return names;
    }
    filter(command, name) {
        if (!name) {
            return false;
        }
        if (name.startsWith("_")) {
            return false;
        }
        if (reserved[name]) {
            return false;
        }
        let self = command;
        if (typeof self[name] === "function") {
            return false;
        }
        if (self[name] == null) {
            return false;
        }
        return true;
    }
    createConfig(command, data) {
        let config = WebApi.createConfig();
        config.url = command.url;
        config.method = command.method.toString();
        if (command.method === HttpMethod.Get) {
            if (typeof data === "object" && data !== null) {
                config.paramsSerializer = params => {
                    return this.serializeParams(params);
                };
            }
            config.params = data;
        }
        else {
            config.data = data;
        }
        return config;
    }
    serializeParams(params) {
        const queryString = [];
        for (const key in params) {
            if (Array.isArray(params[key])) {
                // 配列の中のオブジェクトをシリアライズ
                params[key].forEach((item, index) => {
                    for (const itemKey in item) {
                        if (isNullOrUndefined(item[itemKey])) {
                            continue;
                        }
                        queryString.push(`${key}[${index}].${itemKey}=${encodeURIComponent(item[itemKey])}`);
                    }
                });
            }
            else {
                // 単純なキー・値のペアをシリアライズ
                queryString.push(`${key}=${encodeURIComponent(params[key])}`);
            }
        }
        return queryString.join("&");
    }
}
